// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ft-3";
export var flatBottomCorners = "_ft-5";
export var productImage = "_ft-0";
export var quantityContainer = "_ft-2";
export var quantityHeader = "_ft-6";
export var tooltip = "_ft-1";
export var wrapAndEllipsesOverflow = "_ft-4";